import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetUsers } from 'domains/User/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../PointsHistoryFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const UserFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [users] = useGetUsers()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'user',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`user-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('user')}>
        {t('User')}
      </summary>
      {users?.map((user, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(user)}
            onChange={() => onChange(user)}>
            <Text wordBreak="break-all">
              {user?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

UserFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default UserFilter
